/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */

const oldHosts = [
  {
    code: 'eu',
    name: 'Europe',
    hosts: {
      auth: 'https://eu.iridi.com',
      i3knx: 'https://i3knx.iridi.com',
      i3lite: 'https://i3lite.eu.iridi.com',
      i3pro: 'https://i3pro.eu.iridi.com',
      i3pro_bx: 'https://bkcws.iridi.com/i3pro',
      i3lite_bx: 'https://bkcws.iridi.com/i3lite',
      bus77_home: 'https://bus77home.eu.iridi.com',
      bus77_lite: 'https://bus77lite.eu.iridi.com',
    },
    available: true,
  },
]

const msaHosts = [
  {
    code: 'ru',
    name: 'Russia',
    hosts: {
      auth: 'https://ru.iridi.com',
      auth_api: 'https://auth.ru.iridi.com',
      i3knx: 'https://i3knx.ru.iridi.com',
      i3lite: 'https://i3lite.ru.iridi.com',
      i3pro: 'https://i3pro.ru.iridi.com',
      i3pro_bx: 'https://bkcws.iridi.com/i3pro',
      i3lite_bx: 'https://bkcws.iridi.com/i3lite',
      bus77_home: 'https://bus77home.ru.iridi.com',
      bus77_lite: 'https://bus77lite.ru.iridi.com',
    },
    available: true,
  },
  {
    code: 'eu',
    name: 'Europe',
    hosts: {
      auth: 'https://eu.iridi.com',
      auth_api: 'https://auth.eu.iridi.com',
      i3knx: 'https://i3knx.eu.iridi.com',
      i3lite: 'https://i3lite.eu.iridi.com',
      i3pro: 'https://i3pro.eu.iridi.com',
      i3pro_bx: 'https://bkcws.iridi.com/i3pro',
      i3lite_bx: 'https://bkcws.iridi.com/i3lite',
      bus77_home: 'https://bus77home.eu.iridi.com',
      bus77_lite: 'https://bus77lite.eu.iridi.com',
    },
    available: true,
  },
  {
    code: 'cn',
    name: 'China',
    hosts: {
      auth: 'https://shanghai.58iridi.com',
      auth_api: 'https://auth.shanghai.58iridi.com',
      i3knx: 'https://i3knx.shanghai.58iridi.com',
      i3lite: 'https://i3lite.shanghai.58iridi.com',
      i3pro: 'https://i3pro.shanghai.58iridi.com',
      i3pro_bx: 'https://bkcws.iridi.com/i3pro',
      i3lite_bx: 'https://bkcws.iridi.com/i3lite',
      bus77_home: 'https://bus77home.shanghai.58iridi.com',
      bus77_lite: 'https://bus77lite.shanghai.58iridi.com',
    },
    available: false,
  },
  {
    code: 'test',
    name: 'TEST',
    hosts: {
      auth: 'http://dev.docker.mb',
      auth_api: 'http://auth.dev.docker.mb',
      i3knx: 'http://i3knx.dev.docker.mb',
      i3lite: 'http://i3lite.dev.docker.mb',
      i3pro: 'http://i3pro.dev.docker.mb',
      i3pro_bx: 'http://bkcws.dev.docker.mb/i3pro',
      i3lite_bx: 'http://bkcws.dev.docker.mb/i3lite',
      bus77_home: 'http://bus77home.dev.docker.mb',
      bus77_lite: 'http://bus77lite.dev.docker.mb',
    },
    available: false,
  },
]

const jsonConverter = (in_JsonObj) => {
  if (in_JsonObj != undefined) {
    in_JsonObj = JSON.parse(in_JsonObj)
    const l_ExitJson = {
      Devices:
      [
        {
          Type: 64,
          Name: 'Nest Network',
          Protocol: 'TCP',
          Merge: 1,

          Connection:
            {
              Token: in_JsonObj.token,
              DriverVersion: 1,
            },

          SubDevices: [],
        },
      ],
    }

    for (let i = 0; i < in_JsonObj.device_data.length; i++) {
      let l_ObjDevice = {}
      let l_DeviceTypeID = 0
      const l_FindDeviceID = in_JsonObj.device_data[i].name.split('/')
      const l_DeviceID = l_FindDeviceID[l_FindDeviceID.length - 1]
      const l_FindDeviceType = in_JsonObj.device_data[i].type.split('.')
      let l_DeviceName = l_FindDeviceType[l_FindDeviceType.length - 1]
      if (l_DeviceName == 'THERMOSTAT') {
        l_DeviceName = 'Thermostat'
        l_DeviceTypeID = 0
      }
      if (l_DeviceID != '' && l_DeviceName != '') {
        if (l_DeviceName == 'Thermostat') {
          l_ObjDevice = {
            Name: l_DeviceName,
            Params:
             {
               SubdeviceID: l_DeviceID,
               DeviceType: l_DeviceTypeID,
             },

            Commands:
             [
               {
                 Direction: 1,
                 Name: 'Mode Off',
                 Params:
                   {
                     ThermostatCommand: 0,
                     ThermostatMode: 0,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Heat',
                 Params:
                   {
                     ThermostatCommand: 0,
                     ThermostatMode: 1,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Cool',
                 Params:
                   {
                     ThermostatCommand: 0,
                     ThermostatMode: 2,
                   },
               },
               {
                 Direction: 1,
                 Name: 'HeatCool',
                 Params:
                   {
                     ThermostatCommand: 0,
                     ThermostatMode: 3,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Heat Temperature',
                 Params:
                   {
                     ThermostatCommand: 1,
                     ThermostatTemperatureCommand: 0,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Cool Temperature',
                 Params:
                   {
                     ThermostatCommand: 1,
                     ThermostatTemperatureCommand: 1,
                   },
               },
               {
                 Direction: 1,
                 Name: 'HeatCool High Temperature',
                 Params:
                   {
                     ThermostatCommand: 1,
                     ThermostatTemperatureCommand: 2,
                   },
               },
               {
                 Direction: 1,
                 Name: 'HeatCool Low Temperature',
                 Params:
                   {
                     ThermostatCommand: 1,
                     ThermostatTemperatureCommand: 3,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Eco Mode On',
                 Params:
                   {
                     ThermostatCommand: 2,
                     ThermostatEcoMode: 1,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Eco Mode Off',
                 Params:
                   {
                     ThermostatCommand: 2,
                     ThermostatEcoMode: 0,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Fan Timer On',
                 Params:
                   {
                     ThermostatCommand: 3,
                     FanMode: 1,
                   },
               },
               {
                 Direction: 1,
                 Name: 'Fan Timer Off',
                 Params:
                   {
                     ThermostatCommand: 3,
                     FanMode: 0,
                   },
               },
             ],
            Feedbacks:
             [
               {
                 Direction: 2,
                 Name: 'Mode',
                 Params:
                   {
                     ThermostatFeedback: 0,
                   },
               },
               {
                 Direction: 2,
                 Name: 'HVAC',
                 Params:
                   {
                     ThermostatFeedback: 4,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Eco Mode',
                 Params:
                   {
                     ThermostatFeedback: 2,
                     ThermostatEcoFeedback: 0,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Eco Heat',
                 Params:
                   {
                     ThermostatFeedback: 2,
                     ThermostatEcoFeedback: 1,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Eco Cool',
                 Params:
                   {
                     ThermostatFeedback: 2,
                     ThermostatEcoFeedback: 2,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Temperature Heat',
                 Params:
                   {
                     ThermostatFeedback: 1,
                     ThermostatTemperatureCommand: 0,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Temperature Cool',
                 Params:
                   {
                     ThermostatFeedback: 1,
                     ThermostatTemperatureCommand: 1,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Temperature HeatCool High',
                 Params:
                   {
                     ThermostatFeedback: 1,
                     ThermostatTemperatureCommand: 2,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Temperature HeatCool Low',
                 Params:
                   {
                     ThermostatFeedback: 1,
                     ThermostatTemperatureCommand: 3,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Connectivity',
                 Params:
                   {
                     ThermostatFeedback: 5,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Fan Mode',
                 Params:
                   {
                     ThermostatFeedback: 3,
                     FanTimer: 0,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Fan Timer Timeout',
                 Params:
                   {
                     ThermostatFeedback: 3,
                     FanTimer: 1,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Humidity',
                 Params:
                   {
                     ThermostatFeedback: 6,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Info',
                 Params:
                   {
                     ThermostatFeedback: 7,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Settings',
                 Params:
                   {
                     ThermostatFeedback: 8,
                   },
               },
               {
                 Direction: 2,
                 Name: 'Ambient Temperature',
                 Params:
                   {
                     ThermostatFeedback: 9,
                   },

               },
             ],
          }
        }
        if (JSON.stringify(l_ObjDevice) != JSON.stringify({})) { l_ExitJson.Devices[0].SubDevices.push(l_ObjDevice) }
      }
    }
    return JSON.stringify(l_ExitJson)
  }
  return JSON.stringify({})
}

const jsonConverterYeelightPro = (in_JsonObj) => {
  const l_DeviceTypes = {
    LIGHT: 1,
    CURTAIN: 2,
    SCENE: 3,
    SWITCH: 4,
    FAN: 5,
  }

  const l_TraitsMap = {
    OnOff: 1,
    Brightness: 2,
    ColorSpectrum: 3,
    ColorTemperature: 4,
    OpenClose: 5,
    Scene: 7,
    FanSpeed: 6,
  }

  const l_Channels = {
    1: 'On/Off',
    2: 'Brightness',
    3: 'Change color (RGB)',
    4: 'Color temperature',
    5: 'Range',
    6: 'FanSpeed',
    7: 'Activate Scene',
  }

  const l_ParamName
   = {
     1: 'Light',
     2: 'Curtain',
     4: 'Switch',
     5: 'Fan',
   }

  let l_ExitJson = {}
  if (in_JsonObj != undefined) {
    in_JsonObj = JSON.parse(in_JsonObj)
    l_ExitJson = {
      Devices:
           [
             {
               Type: 94,
               Name: 'Yeelight Pro',
               Protocol: 'TCP',

               Connection:
                 {
                   ServiceType: 13,
                   Token: in_JsonObj.service_token,
                   DriverVersion: 1,
                 },

               SubDevices: [],
             },
           ],
    }
    const l_PayloadDevice = in_JsonObj.devices
    const l_Scenes
     = {
       Name: 'Scenes',
       Params:
                   {
                     DeviceType: 3,
                   },
       Commands: [],
     }
    for (let i = 0; i < l_PayloadDevice.length; i++) {
      if (JSON.stringify(l_PayloadDevice[i]) != JSON.stringify({})) {
        const l_DevID = l_PayloadDevice[i].id
        let l_DevName = l_PayloadDevice[i].name.devicename
        if (l_DevName == undefined) { l_DevName = l_PayloadDevice[i].name.deviceName }

        const l_TypeSplit = l_PayloadDevice[i].type.split('.')
        if (l_TypeSplit.length == 0) continue

        const l_Type = l_TypeSplit[l_TypeSplit.length - 1]
        const l_Traits = l_PayloadDevice[i].traits

        let l_Device = {}
        const l_CodeDevice = l_DeviceTypes[l_Type]
        if (l_CodeDevice != 3) {
          l_Device = {
            Name: l_DevName,
            Params:
                   {
                     DeviceType: l_CodeDevice,
                     DeviceID: l_DevID,
                   },
            Commands: [],
            Feedbacks: [],
          }

          for (let j = 0; j < l_Traits.length; j++) {
            const l_TraitSplit = l_Traits[j].split('.')
            if (l_TraitSplit.length == 0) continue

            const l_ChannelType = l_TraitsMap[l_TraitSplit[l_TraitSplit.length - 1]]
            const l_ChannelName = l_Channels[l_ChannelType]
            const l_Channel
             = {
               Direction: 1,
               Name: l_ChannelName,
               Params: {},
             }

            const l_Tag
             = {
               Direction: 2,
               Name: l_ChannelName,
               Params: {},
             }

            l_Channel.Params[`${l_ParamName[l_CodeDevice]}Command`] = l_ChannelType
            l_Tag.Params[`${l_ParamName[l_CodeDevice]}Tag`] = l_ChannelType
            l_Device.Commands.push(l_Channel)
            l_Device.Feedbacks.push(l_Tag)
          }

          const l_StatusTag = { Direction: 2, Name: 'Device status', Params: {} }
          l_StatusTag.Params[`${l_ParamName[l_CodeDevice]}Tag`] = 8
          l_Device.Feedbacks.push(l_StatusTag)
        } else {
          if (l_Traits.length == 0) continue

          const l_ChannelScene
           = {
             Direction: 1,
             Name: `${l_Channels[7]} ${l_DevID}`,
             Params:
               {
                 ScenesCommand: 7,
                 SceneID: l_DevID,
               },
           }
          l_Scenes.Commands.push(l_ChannelScene)
        }

        if (JSON.stringify(l_Device) != JSON.stringify({})) { l_ExitJson.Devices[0].SubDevices.push(l_Device) }
      }
    }
    if (l_Scenes.Commands.length != 0) { l_ExitJson.Devices[0].SubDevices.push(l_Scenes) }
    l_ExitJson = JSON.stringify(l_ExitJson)
  }
  return l_ExitJson
}

const jsonConverterYeelight = (in_JsonObj) => {
  const l_DeviceTypes = {
    LIGHT: 1,
    CURTAIN: 2,
    SCENE: 3,
    SWITCH: 4,
    FAN: 5,
  }

  const l_TraitsMap = {
    OnOff: 1,
    Brightness: 2,
    ColorSpectrum: 3,
    ColorTemperature: 4,
    OpenClose: 5,
    Scene: 7,
    FanSpeed: 6,
  }

  const l_Channels = {
    1: 'On/Off',
    2: 'Brightness',
    3: 'Change color (RGB)',
    4: 'Color temperature',
    5: 'Range',
    6: 'FanSpeed',
    7: 'Activate Scene',
  }

  const l_ParamName
   = {
     1: 'Light',
     2: 'Curtain',
     4: 'Switch',
     5: 'Fan',
   }

  let l_ExitJson = {}
  if (in_JsonObj != undefined) {
    in_JsonObj = JSON.parse(in_JsonObj)
    l_ExitJson = {
      Devices:
           [
             {
               Type: 94,
               Name: 'Yeelight',
               Protocol: 'TCP',

               Connection:
                 {
                   ServiceType: 12,
                   Token: in_JsonObj.service_token,
                   DriverVersion: 1,
                 },

               SubDevices: [],
             },
           ],
    }
    const l_PayloadDevice = in_JsonObj.devices
    const l_Scenes
     = {
       Name: 'Scenes',
       Params:
                   {
                     DeviceType: 3,
                   },
       Commands: [],
     }
    for (let i = 0; i < l_PayloadDevice.length; i++) {
      if (JSON.stringify(l_PayloadDevice[i]) != JSON.stringify({})) {
        const l_DevID = l_PayloadDevice[i].id
        let l_DevName = l_PayloadDevice[i].name.devicename
        if (l_DevName == undefined) { l_DevName = l_PayloadDevice[i].name.deviceName }

        const l_TypeSplit = l_PayloadDevice[i].type.split('.')
        if (l_TypeSplit.length == 0) continue

        const l_Type = l_TypeSplit[l_TypeSplit.length - 1]
        const l_Traits = l_PayloadDevice[i].traits

        let l_Device = {}
        const l_CodeDevice = l_DeviceTypes[l_Type]
        if (l_CodeDevice != 3) {
          l_Device = {
            Name: l_DevName,
            Params:
                   {
                     DeviceType: l_CodeDevice,
                     DeviceID: l_DevID,
                   },
            Commands: [],
            Feedbacks: [],
          }

          for (let j = 0; j < l_Traits.length; j++) {
            const l_TraitSplit = l_Traits[j].split('.')
            if (l_TraitSplit.length == 0) continue

            const l_ChannelType = l_TraitsMap[l_TraitSplit[l_TraitSplit.length - 1]]
            const l_ChannelName = l_Channels[l_ChannelType]
            const l_Channel
             = {
               Direction: 1,
               Name: l_ChannelName,
               Params: {},
             }

            const l_Tag
             = {
               Direction: 2,
               Name: l_ChannelName,
               Params: {},
             }

            l_Channel.Params[`${l_ParamName[l_CodeDevice]}Command`] = l_ChannelType
            l_Tag.Params[`${l_ParamName[l_CodeDevice]}Tag`] = l_ChannelType
            l_Device.Commands.push(l_Channel)
            l_Device.Feedbacks.push(l_Tag)
          }

          const l_StatusTag = { Direction: 2, Name: 'Device status', Params: {} }
          l_StatusTag.Params[`${l_ParamName[l_CodeDevice]}Tag`] = 8
          l_Device.Feedbacks.push(l_StatusTag)
        } else {
          if (l_Traits.length == 0) continue

          const l_ChannelScene
           = {
             Direction: 1,
             Name: `${l_Channels[7]} ${l_DevID}`,
             Params:
               {
                 ScenesCommand: 7,
                 SceneID: l_DevID,
               },
           }
          l_Scenes.Commands.push(l_ChannelScene)
        }

        if (JSON.stringify(l_Device) != JSON.stringify({})) { l_ExitJson.Devices[0].SubDevices.push(l_Device) }
      }
    }
    if (l_Scenes.Commands.length != 0) { l_ExitJson.Devices[0].SubDevices.push(l_Scenes) }
    l_ExitJson = JSON.stringify(l_ExitJson)
  }
  return l_ExitJson
}

const jsonConverterNetatmo = (in_JsonObj) => {
  const l_ModulesTypes
  = {
    NLP: { Param: { ProductTypePower: 1, Product: 1 }, Code: 1 },
    NLPM: { Param: { ProductTypePower: 2, Product: 1 }, Code: 2 },
    NLPS: { Param: { ProductTypePower: 3, Product: 1 }, Code: 3 },
    NLPT: { Param: { ProductTypePower: 4, Product: 1 }, Code: 4 },

    NLF: { Param: { ProductTypeLighting: 5, Product: 2 }, Code: 5 },
    NLFN: { Param: { ProductTypeLighting: 6, Product: 2 }, Code: 6 },
    NLM: { Param: { ProductTypeLighting: 7, Product: 2 }, Code: 7 },
    NLL: { Param: { ProductTypeLighting: 8, Product: 2 }, Code: 8 },

    NLT: { Param: { ProductTypeScenario: 9, Product: 3 }, Code: 9 },
    NLDP: { Param: { ProductTypeScenario: 10, Product: 3 }, Code: 10 },
  }

  in_JsonObj = JSON.parse(in_JsonObj)

  const l_PayloadDevice = in_JsonObj.devices

  const l_Result = { Devices: [] }

  for (let i = 0; i < l_PayloadDevice.length; i++) {
    if (JSON.stringify(l_PayloadDevice[i]) != JSON.stringify({})) {
      const l_Home
      = {
        Type: 98,
        Name: l_PayloadDevice[i].name,
        Protocol: 'TCP',

        Connection:
            {
              Token: in_JsonObj.service_token,
              HomeID: l_PayloadDevice[i].id,
              DriverVersion: 1,
            },

        RootFolder: [],
      }

      const l_ArrRooms = l_PayloadDevice[i].rooms
      const l_ArrModules = l_PayloadDevice[i].modules

      if (Array.isArray(l_ArrModules)) {
        const l_ListRoomModels = {}
        for (let m = 0; m < l_ArrModules.length; m++) {
          const l_ModuleRoomID = l_ArrModules[m].room_id
          const l_CurrentModuleRoom = l_ArrRooms.find(({ id }) => id === l_ModuleRoomID)
          let l_CurrentRoomName = 'Without room'

          if (l_CurrentModuleRoom != undefined) l_CurrentRoomName = l_CurrentModuleRoom.name

          if (!l_ListRoomModels[l_CurrentRoomName]) l_ListRoomModels[l_CurrentRoomName] = []

          const l_ModuleType = l_ModulesTypes[l_ArrModules[m].type]

          if (l_ModuleType != undefined && l_ListRoomModels[l_CurrentRoomName]) {
            // const l_Element = { Name: l_ArrModules[m].name, Code: l_ModuleType.Code, Params: l_ModuleType.Param }
            const l_Element = { Name: l_ArrModules[m].name, Code: l_ModuleType.Code, Params: { ...l_ModuleType.Param } }
            l_Element.Params.GatewayID = l_ArrModules[m].id
            l_Element.Params.BridgeID = l_ArrModules[m].bridge
            l_ListRoomModels[l_CurrentRoomName].push(l_Element)
          }
        }

        Object.entries(l_ListRoomModels).forEach(([key, value]) => {
          if (value.length != 0) {
            l_Home.RootFolder.push({ Name: key, Items: value })
          }
        })
      }

      l_Result.Devices.push(l_Home)
    }
  }
  return JSON.stringify(l_Result)
}

const jsonConverterAjax = (in_JsonObj) => {
  const l_DeviceTypes = {
    DoorProtect: 2,
    MotionProtect: 3,
    // GlassProtect: 6,
    MotionCam: 7,
    LeaksProtect: 8,
    Socket: 9,
    MotionProtectOutdoor: 10,
    HomeSiren: 11,
    // CombiProtect: 12,
    // FireProtect: 13,
    // FireProtectPlus: 14,
    // RangeExtender: 15,
    MotionCamOutdoor: 16,
    DualCurtainOutdoor: 17,
    Keypad: 18,
    // Transmitter: 19,
    // MultiTransmitter: 20,
    WallSwitch: 21,
    Relay: 22,
    DoorProtectPlus: 23,
    MotionProtectPlus: 24,
    StreetSiren: 25,
    MotionProtectCurtain: 26,
    KeypadPlus: 27,
  }
  let l_ExitJson = {}
  if (in_JsonObj != undefined) {
    in_JsonObj = JSON.parse(in_JsonObj)
    l_ExitJson = {
      Devices:
          [
            {
              Type: 72,
              Name: 'Ajax Network',
              Protocol: 'TCP',
              Merge: 1,

              Connection:
                {
                  Token: in_JsonObj.service_token,
                  DriverVersion: 1,
                },

              SubDevices:
                [
                  {
                    Name: 'Notification',
                    Code: 4,
                    Params:
                   {
                     UseLocalTime: false,
                     DeviceType: 4,
                   },
                  },
                ],
              RootFolder: [],
            },
          ],
    }

    let l_HubFolder = {}
    for (let i = 0; i < in_JsonObj.hubs.length; i++) {
      if (JSON.stringify(in_JsonObj.hubs[i].info) != JSON.stringify({})) {
        const l_HubID = in_JsonObj.hubs[i].info.id
        const l_HubName = in_JsonObj.hubs[i].info.name

        const l_Groups = in_JsonObj.hubs[i].groups
        const l_Devices = in_JsonObj.hubs[i].devices

        l_HubFolder = {
          Name: l_HubName,
          Params:
                {
                  HubID: l_HubID,
                },
          Items:
                [
                  {
                    Name: l_HubName,
                    Code: 1,
                    Params:
                      {
                        DeviceType: 1,
                      },
                  },
                ],
        }

        if (JSON.stringify(l_Devices) != '[]') {
          for (let ind_Device = 0; ind_Device < l_Devices.length; ind_Device++) {
            if (l_Devices[ind_Device].deviceType in l_DeviceTypes) {
              const l_DeviceCode = l_DeviceTypes[l_Devices[ind_Device].deviceType]
              const l_Device
                      = {
                        Name: l_Devices[ind_Device].deviceName,
                        Code: l_DeviceCode,
                        Params:
                         {
                           DeviceID: l_Devices[ind_Device].id,
                           DeviceType: l_DeviceCode,
                         },
                      }
              l_HubFolder.Items.push(l_Device)
            }
          }
        }

        if (JSON.stringify(l_Groups) != '[]') {
          for (let ind_Group = 0; ind_Group < l_Groups.length; ind_Group++) {
            const l_Group
                   = {
                     Name: l_Groups[ind_Group].groupName,
                     Code: 5,
                     Params:
                      {
                        GroupID: l_Groups[ind_Group].id,
                        DeviceType: 5,
                      },
                   }
            l_HubFolder.Items.push(l_Group)
          }
        }
      }

      if (JSON.stringify(l_HubFolder) != JSON.stringify({})) { l_ExitJson.Devices[0].RootFolder.push(l_HubFolder) }
    }
    l_ExitJson = JSON.stringify(l_ExitJson)
  }
  return l_ExitJson
}

export default {
  hosts: process.env.VUE_APP_IS_MSA_BUILD === 'Y' ? msaHosts : oldHosts,
  jsonConverter,
  jsonConverterAjax,
  jsonConverterNetatmo,
  jsonConverterYeelight,
  jsonConverterYeelightPro,
}
